// กรอบ webview (รถ "ระบบเดิม") ทำเหมือนหน้าเดิม (v1) เสมอ: เปิด target_link_video_realtime ใน iframe ตามที่อยู่ใน DB
// ไม่แปลงลิงก์ ไม่ยิงอะไรเพิ่ม ไม่มีสถานะ ไม่มีปุ่มลองใหม่ — ของพวกนั้นเป็นของโหมดยิงตรง

import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { Cell, CellBody } from '../styles/wall'
import { ChannelName, Header, HeaderRight, IconBtn } from '../styles/cell'

// iframe เปิดอะไรก็ได้ในกรอบ (ถึงขั้น javascript: ที่อ่าน token ได้) จึงเปิดเฉพาะลิงก์ http(s)
function isWebLink(url) {
  return typeof url === 'string' && /^https?:\/\//i.test(url)
}

export default function WebviewCell({
  vehicle,
  selected,
  txt,
  onSelect,
  onRemove,
}) {
  const link = vehicle.target_link_video_realtime
  const close = event => {
    event.stopPropagation()
    onRemove()
  }

  return (
    <Cell selected={selected} onClick={onSelect}>
      <Header>
        <ChannelName>{vehicle.plate_no}</ChannelName>
        <HeaderRight>
          <Tooltip title={txt.close}>
            <IconBtn type="button" danger onClick={close}>
              ✕
            </IconBtn>
          </Tooltip>
        </HeaderRight>
      </Header>
      <CellBody>
        {isWebLink(link) && <iframe src={link} title={vehicle.plate_no} />}
      </CellBody>
    </Cell>
  )
}

WebviewCell.propTypes = {
  vehicle: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  txt: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  onRemove: PropTypes.func,
}
